<template>
    <div>
        <v-card
            class="pa-4"
        >
            <!-- Header -->
            <div class="d-flex justify-space-between align-center">
                <v-card-title class="text-h6 font-weight-bold pa-0">
                  <v-icon color="red" left class="mr-2">mdi-heart</v-icon>
                    Donation Form
                </v-card-title>
                <v-btn icon @click="$emit('close-dialog')"> 
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-divider class="mb-1"></v-divider>

            <!-- Donation Amount -->
            <v-card-subtitle class="font-weight-bold">Donation Amount</v-card-subtitle>

            <v-btn-toggle
              v-model="donationAmount"
              class="my-2 flex-wrap"
              mandatory
              tile
            >
              <v-btn
                v-for="amount in [1, 2, 5, 10, 20, 50, 100]"
                :key="amount"
                :value="amount"
                depressed
                @click="customAmount = ''"
              >
                ${{ amount }}
              </v-btn>

              <!-- Proper 'Other' button -->
              <v-btn depressed :value="'Other'">
                Other
              </v-btn>
            </v-btn-toggle>

            <!-- Custom Amount Field -->
            <v-expand-transition>
              <div v-if="donationAmount === 'Other'">
                <v-text-field
                  v-model="customAmount"
                  label="Enter custom amount"
                  type="number"
                  outlined
                  dense
                  class="mt-2"
                  prefix="$"
                  min="1"
                ></v-text-field>
              </div>
            </v-expand-transition>

            <!-- Donation Frequency -->
            <v-card-subtitle class="font-weight-bold mt-1">Donation frequency</v-card-subtitle>
            <v-btn-toggle
            v-model="donationFrequency"
            mandatory
            tile
            >
            <v-btn depressed>One Time</v-btn>
            <v-btn depressed>Monthly</v-btn>
            <v-btn depressed>Annual</v-btn>
            </v-btn-toggle>

            <!-- Email -->
            <v-text-field
            label="E-mail address"
            outlined
            dense
            class="mt-2"
            v-model="email"
            ></v-text-field>

            <!-- Cardholder Name -->
            <v-text-field
            label="Cardholder's name"
            outlined
            dense
            class="mt-2"
            v-model="cardName"
            ></v-text-field>

            <!-- Secure link text -->
            <div class="d-flex align-center mt-2">
            <v-icon color="green" small>mdi-lock</v-icon>
            <span class="ml-1 text-body-2 blue--text text--darken-1">
                Secure, 1-click checkout with Link
            </span>
            </div>

            <!-- Card Fields -->
            <v-text-field
            label="Card number"
            outlined
            dense
            prepend-inner-icon="mdi-credit-card-outline"
            class="mt-2"
            v-model="cardNumber"
            ></v-text-field>

            <v-row>
            <v-col cols="6">
                <v-text-field label="Expiry" outlined dense v-model="expiry"></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field label="CVC" outlined dense v-model="cvc"></v-text-field>
            </v-col>
            </v-row>

            <v-row>
            <v-col cols="6">
                <v-select
                label="Country"
                outlined
                dense
                :items="['United States', 'Canada', 'United Kingdom']"
                v-model="country"
                ></v-select>
            </v-col>
            <v-col cols="6">
                <v-text-field label="ZIP" outlined dense v-model="zip"></v-text-field>
            </v-col>
            </v-row>

            <!-- Terms -->
            <p class="text-caption grey--text mt-2">
            By providing your card information, you allow Narmina Balabayli to charge your card for future payments in accordance with their terms.
            </p>

            <!-- Donate Button -->
            <v-card-actions class="pa-0 mt-4">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                class="white--text"
                @click="submitForm"
            >
                Donate
            </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {
  data: () => ({
    donationAmount: 20,
    customAmount: '',
    donationFrequency: 'Monthly',
    email: '',
    cardName: '',
    cardNumber: '',
    expiry: '',
    cvc: '',
    country: 'United States',
    zip: '',
  }),
  methods: {
    submitForm() {
      const amount =
        this.donationAmount === 'Other'
          ? this.customAmount || '0'
          : this.donationAmount

      alert(`Donation submitted for $${amount}!`)
      this.showForm = false
    },
  },
  mounted: {
    postPingWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return 430;
        case 'lg': return 430;
        case 'xl': return 430;
        default: return 430; // Default value if no match
      }
    }
  },
}
</script>

<style scoped>
.v-dialog__content--active {
  background-color: rgba(0, 0, 0, 0.5);
}

/* Prevent side overflow on mobile */
.v-dialog {
  margin: 0 !important;
  max-width: 100vw !important;
}

.v-card {
  box-sizing: border-box;
}
</style>
